import { render, staticRenderFns } from "./assign_menus.vue?vue&type=template&id=dc3c824a"
import script from "./assign_menus.vue?vue&type=script&lang=js"
export * from "./assign_menus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc3c824a')) {
      api.createRecord('dc3c824a', component.options)
    } else {
      api.reload('dc3c824a', component.options)
    }
    module.hot.accept("./assign_menus.vue?vue&type=template&id=dc3c824a", function () {
      api.rerender('dc3c824a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/settings/assign_menus.vue"
export default component.exports